function formatStatus(status = "") {
  return status
    .split(/[_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

function capitalizeFirst(str = "") {
  return formatStatus(str);
//   return (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase());
}
export default capitalizeFirst;
